module.exports = __webpack_public_path__ + "a8e57e03383ea7a5dcd8ce27769db138.pdf";